<template>
  <div>
    <v-dialog ref="root-user-dashboard-status-dialog" v-model="rootUserDialog" width="800">
      <v-card>
        <v-card-title>{{ $t('dashboard_status') }}</v-card-title>
        <v-card-text>
          <div v-if="!vehicle.exclude_from_dashboard">
            <p class="mb-4">
              {{ $t('vehicle_view_ui.exclude_from_dashboard_modal_message') }}
            </p>
            <v-textarea
              outlined
              v-model.trim="excludeFromDashboardReason"
              height="150"
              :error-messages="exclusionReasonErrors"
              :label="$t('vehicle_view_ui.exclusion_reason')"/>
            <resource-notes
              v-if="vehicle.notes"
              :showAddButton="false"
              :showEditor="false"
              :notes="vehicle.notes"
              :limitToContexts="['frontend/form/vehicle/exclude-from-dashboard']"/>
          </div>
          <div v-else>
            <span class="my-4">
              {{ $t('vehicle_view_ui.include_in_dashboard_modal_message') }}
            </span>
            <resource-notes
              v-if="vehicle.notes"
              :showAddButton="false"
              :showEditor="false"
              :notes="vehicle.notes"
              :limitToContexts="['frontend/form/vehicle/exclude-from-dashboard']"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="closeDialog">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" @click="toggleDashboardExclusion" :loading="updating">
            {{ vehicle.exclude_from_dashboard ? $t('include') : $t('exclude') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog ref="regular-user-dashboard-status-dialog" v-model="regularDialog" width="800">
      <v-card>
        <v-card-title>{{ $t('dashboard_status') }}</v-card-title>
        <v-card-text>
          <div v-if="!vehicle.exclude_from_dashboard">
            <span class="my-4" v-html="$t('vehicle_view_ui.exclude_from_dashboard_modal_message_unprivileged')"></span>
            <resource-notes
              v-if="vehicle.notes"
              :showAddButton="false"
              :showEditor="false"
              :notes="vehicle.notes"
              :limitToContexts="['frontend/form/vehicle/exclude-from-dashboard']" />
          </div>
          <div v-else>
            <span class="my-4" v-html="$t('vehicle_view_ui.include_in_dashboard_modal_message_unprivileged')"></span>
            <resource-notes
              v-if="vehicle.notes"
              :showAddButton="false"
              :showEditor="false"
              :notes="vehicle.notes"
              :limitToContexts="['frontend/form/vehicle/exclude-from-dashboard']" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="closeDialog">
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ResourceNotes from '@/components/shared/ResourceNotes'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import VehicleRecord from '@/orm/models/VehicleRecord'
import { and as vuelidateAnd, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'DashboardExclusionDialog',
  components: {
    ResourceNotes
  },
  mixins: [
    CurrentUserMixin,
    ValidationMixin
  ],
  props: {
    vehicle: VehicleRecord
  },
  validations: {
    excludeFromDashboardReason: {
      requiredMinLength: vuelidateAnd(
        minLength(3),
        required
      )
    }
  },
  data () {
    return {
      rootUserDialog: false,
      regularDialog: false,
      excludeFromDashboardReason: '',
      updating: false
    }
  },
  computed: {
    rootUser () {
      return this.user.can('update_rootentity')
    },
    exclusionReasonErrors () {
      return this.validationErrors([{
        prop: this.$v.excludeFromDashboardReason,
        message: this.$t('vehicle_view_ui.exclude_from_dashboard_reason_required')
      }])
    }
  },
  methods: {
    showDialog () {
      if (this.rootUser) {
        this.excludeFromDashboardReason = ''
        this.$v.$reset()
        this.rootUserDialog = true
      } else {
        this.regularDialog = true
      }
    },
    closeDialog () {
      this.rootUserDialog = false
      this.regularDialog = false
    },
    async toggleDashboardExclusion () {
      // Update to true (along with adding the note)
      if (!this.vehicle.exclude_from_dashboard) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return false
        }
        const newNote = {
          resource: 'vehicle',
          entity_id: this.vehicle.id,
          user_id: this.user.id,
          note: this.excludeFromDashboardReason,
          context: 'frontend/form/vehicle/exclude-from-dashboard'
        }
        try {
          this.updating = true
          const note = await this.$orm('Note').createOrUpdate(newNote, {
            params: {
              expand: 'user_email',
              fields: 'id,note,created,user_email,context'
            }
          })
          this.rootUserDialog = false
          this.vehicle.notes.push(note)
          await this.$orm('Vehicle').update(this.vehicle.id, {
            exclude_from_dashboard: true
          })
          this.$emit('update', true)
        } catch (error) {
          this.handleError(error)
        } finally {
          this.updating = false
        }
      // Update to false (no note required)
      } else {
        try {
          this.updating = true
          await this.$orm('Vehicle').update(this.vehicle.id, {
            exclude_from_dashboard: false
          })
          this.rootUserDialog = false
          this.$emit('update', false)
        } catch (error) {
          this.handleError(error)
        } finally {
          this.updating = false
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
